function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "options",
  transform: "translate(-4.5 -4.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11907",
  "data-name": "Path 11907",
  d: "M12.359,4.5a7.862,7.862,0,0,1,7.611,5.893H35.934v3.929H19.969A7.859,7.859,0,1,1,12.359,4.5Zm0,11.788a3.929,3.929,0,1,0-3.929-3.929A3.929,3.929,0,0,0,12.359,16.288Z",
  transform: "translate(0 0)",
  fill: "#ac1ede",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11908",
  "data-name": "Path 11908",
  d: "M31.076,33.713a7.862,7.862,0,0,1-7.611-5.893H7.5V23.89H23.465a7.859,7.859,0,1,1,7.611,9.823Zm0-3.929a3.929,3.929,0,1,0-3.929-3.929A3.929,3.929,0,0,0,31.076,29.783Z",
  transform: "translate(0.929 4.186)",
  fill: "#ac1ede",
  fillRule: "evenodd"
}));

var SvgOptions = function SvgOptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.363,
    height: 33.399,
    viewBox: "0 0 35.363 33.399",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/options.f6787387.svg";
export { ForwardRef as ReactComponent };